<script setup lang="ts">
const props = defineProps<{
  src: string
}>()

const url = computed(() => `url('${props.src}')`)
</script>

<template>
  <figure class="flex select-none items-center justify-center" />
</template>

<style scoped>
figure {
  mask-image: v-bind(url);
  mask-size: cover;
  -webkit-mask-image: v-bind(url);
  -webkit-mask-size: cover;
}
</style>
